import { render, staticRenderFns } from "./TableLoader.vue?vue&type=template&id=6b2e198b&scoped=true"
import script from "./TableLoader.vue?vue&type=script&lang=js"
export * from "./TableLoader.vue?vue&type=script&lang=js"
import style0 from "./TableLoader.vue?vue&type=style&index=0&id=6b2e198b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2e198b",
  null
  
)

export default component.exports